import consumer from "./consumer";

consumer.subscriptions.create("RecordChannel", {
  connected() {},

  disconnected() {},

  rejected() {},
});
